module.exports = __webpack_public_path__ + "img/heart.8592a20d.svg";